import { CommonButton } from "@components/CommonButton";
import { KdAlert } from "@kalodata/kds-design";
import { IconLinePlus } from "@kalodata/kds-design-icons";
import { Trans } from "react-i18next";
import LinkedAccountsEmptyIllustration from "@icons/add-account.svg?react";
import { twMerge } from "tailwind-merge";

interface LinkAccountIllustrationProps {
  className?: string;
  alertClassName?: string;
  onConnect: () => void;
  loading: boolean;
}

export const LinkAccountIllustration = (props: LinkAccountIllustrationProps) => {
  const { onConnect, loading, className, alertClassName } = props;
  return (
    <div className={twMerge("flex flex-1 flex-col gap-[16px]", className)}>
      <KdAlert
        type="info"
        className={twMerge("rounded-none border-none", alertClassName)}
        content={
          <div className="flex flex-col text-[14px] leading-[20px] text-kds-fg-soft">
            <p>
              <Trans>Currently only TikTok US is supported</Trans>
            </p>
            <p className="flex flex-wrap items-center gap-[4px]">
              <Trans>Before adding an account, please ensure your network is located in the 🇺🇸 US.</Trans>
            </p>
          </div>
        }
      />
      <div className="flex flex-1 flex-col items-center justify-center gap-[8px] py-[24px]">
        <LinkedAccountsEmptyIllustration className="size-[110px] shrink-0 text-kds-fg-soft" />
        <div className="flex flex-col items-center gap-[16px]">
          <div className="flex max-w-[420px] flex-col items-center gap-[4px] text-center">
            <p className="text-[16px] font-medium leading-[1.4] text-kds-fg">
              <Trans>No Account Connected</Trans>
            </p>
            <p className="text-[13px] font-normal leading-[1.4] text-kds-fg-soft">
              <Trans>Connect your accounts to enable 1-click publishing</Trans>
            </p>
          </div>
          <CommonButton
            type="primary"
            size="large"
            icon={<IconLinePlus size={20} />}
            className="h-[40px] px-[16px]"
            loading={loading}
            onClick={onConnect}
          >
            <Trans>Connect Account</Trans>
          </CommonButton>
        </div>
      </div>
    </div>
  );
};
